import { Center } from '@chakra-ui/react'

import { getColorHexValue } from 'src/lib/utils'
import { BrandColor } from 'src/types'

const InsideCustomIcon: React.FC<{
  brandColor: BrandColor
  children: React.ReactNode
}> = ({ brandColor, children }) => (
  <Center
    boxSize="64px"
    borderRadius="full"
    bg={`${getColorHexValue(brandColor)}1A`}
  >
    {children}
  </Center>
)

export default InsideCustomIcon
